module.exports = __webpack_public_path__ + "assets/img/11_1794.977a0be6.jpg";